import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import NFeEventoCode from "./NFe.Evento.Code";
import NFeEventoModalPropriedades from "./Modal.Propriedades/NFe.Evento.Modal.Propriedades";
import { NFeEventoDto } from "./NFe.Evento.Dto";
import NFeEventoModalCadastro from "./Modal.Cadastro/NFe.Evento.Modal.Cadastro";
import React from "react";

const NFeEventoView = () => {
  const code = NFeEventoCode();

  return (
    <Container>
      <HeadPage headText="Eventos">
        <Dropdown.Item
          as={Button}
          onClick={() => code.onShowModalCadastro(true)}
        >
          Incluir...
        </Dropdown.Item>
      </HeadPage>
      {!code.loading ? (
        <Col>
          {code.data && code.data.length > 0 ? (
            <Table responsive hover>
              <thead>
                <tr>
                  <th className="col-4">Tipo Evento</th>
                  <th className="col-4">Justificativa/Correção</th>
                  <th className="col-4">Envio Descrição</th>
                </tr>
              </thead>
              <tbody>
                {code.data.map((item: NFeEventoDto) => (
                  <React.Fragment key={item.id}>
                    <tr
                      style={{ cursor: "pointer" }}
                      onClick={code.handleClickPropriedades(item)}
                    >
                      <td className="col-4">{item.tipoEventoDescricao}</td>
                      <td className="col-4">
                        {item.cancelamento?.justificativaCancelamento}
                        {item.correcao?.descricaoCorrecao}
                      </td>
                      <td className="col-4">
                        {item.codigoStatusEnvioDescricao}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3} className="p-2">
                        {item.codigoStatusResposta} -{" "}
                        {item.descricaoMotivoResposta}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          ) : (
            <Form.Text>Sem Dados</Form.Text>
          )}
        </Col>
      ) : (
        <Placeholder animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
      <NFeEventoModalPropriedades
        show={code.modalShowPropriedades}
        evento={code.evento}
        onReturn={code.onReturnModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
      />
      <NFeEventoModalCadastro
        show={code.modalShowCadastro}
        nfeId={code.nfeId}
        onClose={code.onShowModalCadastro}
        onReload={code.onReloadModalPropriedades}
      />
    </Container>
  );
};

export default NFeEventoView;
